import { render, staticRenderFns } from "./AdvertiserOutput.vue?vue&type=template&id=ef9a00a8&scoped=true"
import script from "./AdvertiserOutput.vue?vue&type=script&lang=js"
export * from "./AdvertiserOutput.vue?vue&type=script&lang=js"
import style0 from "./AdvertiserOutput.vue?vue&type=style&index=0&id=ef9a00a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9a00a8",
  null
  
)

export default component.exports